const filterActiveNow = state => {
  const { activeData, signOnOffData, projects, hauls, loading, filters } = state.activeNow
  const isForeman = state.user.userData && state.user.userData.isForeman ? true : false
  const foreman = state.user.userData

  const hasHaulFilters = filters.hauls.length
  const hasProjectFilters = filters.projects.length
  let filteredActiveNow = null
  let haulToProjectMap = {}
  let projectToHaulMap = {}
  let foremanHaul = null
  if (!loading && !state.hauls.loading) {
    state.hauls.haulList.forEach(haul => {
      haulToProjectMap[haul.haulId] = haul.project.projectName
      if (projectToHaulMap[haul.project.projectName]) {
        projectToHaulMap[haul.project.projectName].push(haul.haulId)
      } else {
        projectToHaulMap[haul.project.projectName] = [haul.haulId]
      }
      if (
        isForeman &&
        ((haul.siteContact && haul.siteContact.phoneNumber === foreman.phone) ||
          (haul.superIntendant && haul.superIntendant.phoneNumber === foreman.phone))
      ) {
        foremanHaul = haul
      }
    })

    const filteredSignOnOff = signOnOffData.filter(
      item =>
        (!hasHaulFilters && !hasProjectFilters) ||
        (hasProjectFilters && filters.projects.includes(item.projectName)) ||
        (hasHaulFilters && filters.hauls.includes(item.haulId))
    )

    filteredActiveNow = {
      activeData: activeData.filter(
        item =>
          (!hasHaulFilters && !hasProjectFilters) ||
          (hasProjectFilters && filters.projects.includes(item.haul.project.projectName)) ||
          (hasHaulFilters && filters.hauls.includes(item.haul.haulId))
      ),
      projects: projects.filter(
        project =>
          (!hasHaulFilters && !hasProjectFilters) ||
          (hasProjectFilters && filters.projects.includes(project)) ||
          (hasHaulFilters &&
            projectToHaulMap[project].filter(haul => filters.hauls.includes(haul)).length)
      ),
      hauls: hauls.filter(
        haul =>
          (!hasHaulFilters && !hasProjectFilters) ||
          (hasHaulFilters && filters.hauls.includes(haul)) ||
          (hasProjectFilters && filters.projects.includes(haulToProjectMap[haul]))
      ),
      signOnOffData: filteredSignOnOff,
      drivers: Array.from(new Set(filteredSignOnOff.map(item => item.driverId))),
      loading,
      filters
    }
  }
  return filteredActiveNow
}

export { filterActiveNow }
